<template>
    <div>
        <div class="swiper swiper">
            <div class="swiper-wrapper">
                <div v-for="(image, index) in images" :key="index" class="swiper-slide">
                    <img :src="image" class="active" alt="">
                    <!-- <div class="popup__image--iframe-click" @click="openPopupInPopup($event)">
                        <img :src="'./media/images/marine/monitoring/button.png'" />
                    </div> -->
                </div>
            </div>
        </div>
        <div class="popup__navigation">
            <div class="popup__navigation-prev" @click.prevent="handlePrevSlide">
                <ChevronLeftIcon />
            </div>
            <div class="popup__navigation-next" @click.prevent="handleNextSlide">
                <ChevronRightIcon />
            </div>
        </div>
    </div>
</template>

<script>
import { gsap } from 'gsap';
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';

import ChevronLeftIcon from './ChevronLeftIcon.vue';
import ChevronRightIcon from './ChevronRightIcon.vue';

export default {
    props: {
        images: {
            type: Array,
            default: () => []
        }
    },

    components: {
        ChevronLeftIcon,
        ChevronRightIcon
    },

    data() {
        return {
            swiper: null,
            swiperEl: null,
            swiperSlides: null,
            currentSlideIndex: 0,
            statusOnline: false
        };
    },

    mounted() {
        this.swiperEl = this.$el.querySelector('.swiper');
        this.swiperSlides = this.$el.querySelectorAll('.swiper-slide');

        // console.log(this.images);

        this.initSwiper();

        EventBus.$on('open-popup', (slide) => {
            this.reInitSwiper();
            gsap.delayedCall(0.1, () => {
                this.swiper.update();
                this.swiper.slideToLoop(slide, 0);
            });
            gsap.delayedCall(0.3, () => {
                gsap.to('.popup__content', { opacity: 1, duration: 0.3 });
            });
        });

        this.statusOnline = navigator.onLine;
    },

    methods: {
        openPopupInPopup() {
            this.$parent.openPopupIframe();
        },

        initSwiper() {
            if (this.swiper) {
                return;
            }

            this.swiper = new Swiper(this.swiperEl, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                touchRatio: 2,
                speed: 1000
            });

            this.swiper.on('realIndexChange', () => {
                this.currentSlideIndex = this.swiper.realIndex;
            });

            this.swiper.on('slideChangeTransitionEnd', (swiper) => {
                // if (this.swiper.realIndex === 0) {
                //     this.reInitSwiper();
                // }

                this.currentSlideIndex = swiper.realIndex;
            });
        },

        destroySwiper() {
            if (!this.swiper) {
                return;
            }

            this.swiper.destroy();
            this.swiper = null;
        },

        reInitSwiper() {
            this.destroySwiper();
            this.initSwiper();
        },

        handlePrevSlide() {
            if (!this.swiper) {
                return;
            }

            this.swiper.slidePrev();
        },

        handleNextSlide() {
            if (!this.swiper) {
                return;
            }

            this.swiper.slideNext();
        },

        switchImage(event) {
            event.currentTarget.nextElementSibling.classList.toggle('active');
            event.currentTarget.nextElementSibling.nextElementSibling.classList.toggle('active');
        }
    }
};
</script>
